/// <amd-module name="VSS/Features/SignalR/HubProxies.types" />
export interface ISignalRHubProxy<C, S> {
    client: C;
    server: S;
    invoke: any;
}
